{
  "sm": 576,
  "md": 768,
  "lg": 992,
  "xl": 1220,
  "header-medium": 1134,
  "header-wide": 1420
}
